import { Injectable } from '@angular/core';
import { map, merge, Observable, repeatWhen, shareReplay, Subject, switchMap } from 'rxjs';
import { KkmAvailableOperations } from '../../../../core/modules/kkms/kkms.types';
import { IKkm, RetailPlace } from '../../../../core/modules/retail-places/retail-paces.types';
import { KkmsDetailsService } from '../../../../core/services/kkm-details.service';
import { RetailPlacesApiService } from '../../../../core/modules/retail-places/retail-places-api.service';
import { getRouteParam } from '../../../../shared/utils/getRouteParam.utils';

@Injectable()

export class KkmSettingsStateService {
  readonly tariffActivated$ = new Subject<void>();
  readonly kkmUpdated$ = new Subject<void>();
  readonly kkm$: Observable<IKkm & KkmAvailableOperations> = this.getKkm();
  readonly retailPlace$: Observable<RetailPlace> = this.getRetailPlace();

  constructor(
    private retailPlaceApiService: RetailPlacesApiService,
    private kkmDetailsService: KkmsDetailsService,
  ) {}

  private getKkm(): Observable<IKkm & KkmAvailableOperations> {
    return getRouteParam('id')
      .pipe(
        switchMap(kkmId => this.kkmDetailsService.getKkm(kkmId)
          .pipe(repeatWhen(() => merge(this.tariffActivated$, this.kkmUpdated$)))),
        shareReplay({
          refCount: true,
        }),
      );
  }

  private getRetailPlace(): Observable<RetailPlace> {
    return this.kkm$.pipe(
      map(kkm => kkm.retailPlaceId),
      switchMap(id => this.retailPlaceApiService.fetchRetailPlace(id)),
    );
  }
}
